import { useStaticQuery, graphql } from 'gatsby'

const mapDataToTitleCategory = data => {
  return data?.map(post => ({
    id: post.id,
    title: post.postFlexContent?.customHeader || post.title,
    category: post.categories?.nodes[0]?.name,
    categorySlug: post.categories?.nodes[0]?.slug,
    uri: post.uri,
  }))
}

export const usePopularPostsQuery = () => {
  const data = useStaticQuery(graphql`
    #  TODO Update query
    {
      allWpPost(
        filter: {
          categories: { nodes: { elemMatch: { slug: { eq: "heta-nyheter" } } } }
        }
      ) {
        nodes {
          id
          slug
          uri
          title
          postFlexContent {
            customHeader
          }
          categories {
            nodes {
              name
              slug
            }
          }
        }
      }
    }
  `)

  return mapDataToTitleCategory(data?.allWpPost?.nodes)
}
